import { useRedux } from '../modularRedux';

type Layout = 'default' | 'compressed';
const initialState: Layout = 'default';

export const storeKey = 'layout';

export const [useLayout, useLayoutDispatchers, layoutActions] = useRedux(
  storeKey,
  {
    setLayout: (state, l: Layout) => l
  },
  initialState as Layout
);
